import photo_1 from "./TimeSquarePictures/Photo1.webp";
import photo_2 from "./TimeSquarePictures/Photo2.webp";
import photo_3 from "./TimeSquarePictures/Photo3.webp";
import photo_4 from "./TimeSquarePictures/Photo4.webp";

export const TimeSquarePhotoContent = [
  {
    id: 1,
    title: "Photos",
    latestPicture: {
      image: photo_4,
      date: "20 Jul 2024",
      time: "9:01pm",
      location: "",
    },
    pictures: [
      {
        image: photo_4,
        date: "20 Jul 2024",
        time: "9:01pm",
        location: "",
      },
      {
        image: photo_3,
        date: "4 Nov 2022",
        time: "9:53pm",
        location: "",
      },
      {
        image: photo_2,
        date: "14 Apr 2022",
        time: "11:58pm",
        location: "",
      },
      {
        image: photo_1,
        date: "22 Mar 2021",
        time: "2:46pm",
        location: "",
      },
    ],
  },
];
